import { Trans } from '@lingui/react'
import type { VFC } from 'react'

import AttributePickerValue from './AttributePickerValue'

interface ExcludedAttributeValueProps {
  attributeValue: string
  code: string
  attributeLabel?: string
}

const ExcludedAttributeValue: VFC<ExcludedAttributeValueProps> = ({
  attributeValue,
  code,
  attributeLabel,
}) => {
  let excludedAttributeLabel
  switch (code) {
    case 'package_size':
      excludedAttributeLabel = (
        <Trans id="variantAttributes.label.package_size" />
      )
      break
    case 'color_number':
      excludedAttributeLabel = (
        <Trans id="variantAttributes.label.color_number" />
      )
      break
    default:
      excludedAttributeLabel = attributeLabel
      break
  }
  return (
    <div className="u-padding-small--bottom u-padding-small--top l-flex o-ExcludedAttributeValue">
      <span className="u-margin-xx-small--right l-flex--end o-ExcludedAttributeValue__label">
        {excludedAttributeLabel}:{' '}
      </span>
      <AttributePickerValue
        pickerValue={attributeValue}
        variantAttributeType={code === 'color_number' ? 'color' : code}
        packageSizeAttribute={code === 'package_size'}
        displayExcludedValues
      />
    </div>
  )
}

export default ExcludedAttributeValue
